import { createModalHelpers, useModalStore } from "@stores/unified-modal.store";
import { FC } from "react";
import Modal from "../Modal";
import ModalContent from "../Modal/ModalContent";
import { AssetButton } from "@components/common/AssetButton";
import { IAssetInfo } from "@stores/meme-swap.store";
import Separator from "@/components/ui/separator";
import ModalCloseButton from "@components/ui/ModalCloseButton";

const MemeSwapConfirm: FC<{
    assetInInfo: IAssetInfo;
    assetOutInfo: IAssetInfo;
    title: string;
    children: React.ReactNode;
}> = ({ assetInInfo, assetOutInfo, title, children }) => {
    const modalHelpers = createModalHelpers();
    const { openModal, closeModal } = modalHelpers;
    const isVisible = useModalStore((s) => s.modalStates.memeSwap);
    return (
        <Modal
            isVisible={isVisible}
            setIsVisible={(visible) => (visible ? openModal("memeSwap") : closeModal("memeSwap"))}
        >
            <ModalContent classNames={""}>
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-medium">{title} </h2>
                    <ModalCloseButton
                        className={
                            "bg-card p-2 rounded-full border border-muted hover:rotate-90 transition-transform duration-300"
                        }
                        onClick={() => closeModal("memeSwap")}
                    />
                </div>
                <div className="flex flex-col items-center justify-between gap-3 rounded-2xl border border-muted p-4 bg-card">
                    <div className="flex items-center gap-2 justify-between w-full">
                        <span className="text-xl">Sell</span>
                        <div className="flex items-center gap-2">
                            <span className="text-3xl">{assetInInfo.amount}</span>
                            {assetInInfo.asset && <AssetButton asset={assetInInfo.asset} seletable={false} />}
                        </div>
                    </div>
                    <Separator />
                    <div className="flex items-center gap-2 justify-between w-full">
                        <span className="text-xl">Buy</span>
                        <div className="flex items-center gap-2">
                            <span className="text-xs">{Number(assetInInfo.amount) / Number(assetOutInfo.price)}</span>
                            {assetOutInfo.asset && <AssetButton asset={assetOutInfo.asset} seletable={false} />}
                        </div>
                    </div>
                </div>

                {children}
            </ModalContent>
        </Modal>
    );
};

export default MemeSwapConfirm;
